"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneFormat = void 0;
var phoneFormat = exports.phoneFormat = function phoneFormat(value) {
  var fixed = (value || '').replace(/\s|\(|\)|-/g, '');
  if (fixed.startsWith('55') || fixed.startsWith('33') || fixed.startsWith('55')) {
    return '(##) ####-####';
  }
  return '(###) ###-####';
};